interface IPause {
  onClick?: () => void;
  width?: number;
  height?: number;
  color?: string;
}

export const Pause = ({ onClick, width = 20, height = 30, color = 'black' }: IPause) => {
  return (
    <svg
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      data-qa="pause_icon"
      aria-label="pause"
      viewBox="0 0 20 30"
      fill={color}
    >
      <rect x="0.25" width="7.3077" height="29.2308" fill={color} />
      <rect x="11.9423" width="7.3077" height="29.2308" fill={color} />
    </svg>
  );
};
